import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';

const LanguageProvider = ({ locale, messages, children }) => {
  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      {React.Children.only(children)}
    </IntlProvider>
  );
};

LanguageProvider.propTypes = {
  locale: PropTypes.string.isRequired,
  messages: PropTypes.object.isRequired,
  children: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  locale: state.locale.locale,
});

export default memo(connect(mapStateToProps)(LanguageProvider));
